import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';

import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { MobileAccessibility } from '@ionic-native/mobile-accessibility/ngx';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Camera } from '@ionic-native/camera/ngx';

import { API } from './config';

import { MyApp } from './app.component';
import { HomepageComponent } from '../pages/home/home';
import { MainNavigationComponent } from '../pages/menu/menu';
import { HeaderComponent } from '../pages/header/header';
import { RapportSansAccesComponent } from '../pages/rapport-sans-acces/rapport-sans-acces';
import { ConnexionComponent } from '../pages/connexion/connexion';
import { SavoirPlusComponent } from '../pages/savoir-plus/savoir-plus';
import { DerniersScansComponent } from '../pages/derniers-scans/derniers-scans';
import { ListeElementsVerifiesComponent } from '../pages/liste-elements-verifies/liste-elements-verifies';
import { ElementVerifieComponent } from '../pages/element-verifie/element-verifie';
import { RechercheComponent } from '../pages/recherche/recherche';
import { RapportComponent } from '../pages/rapport/rapport';
import { FiltresComponent } from '../pages/filtres/filtres';
import { ListeObservationsRapportComponent } from '../pages/liste-observations-rapport/liste-observations-rapport';
import { ListeObservationsVerifiesComponent } from '../pages/liste-observations-verifies/liste-observations-verifies';
import { DetailsObservationComponent } from '../pages/details-observation/details-observation';
import { SuiviObservationComponent } from '../pages/suivi-observation/suivi-observation';
import { MotDePasseOublieComponent } from '../pages/mot-de-passe-oublie/mot-de-passe-oublie';

import { ApiService } from './shared/services/api.service';
import { AuthService } from './shared/services/auth.service';
import { ElementsService } from './shared/services/elements.service';
import { RapportService } from './shared/services/rapport.service';
import { qrCodeService } from './shared/services/qrCode.service';
import { ObservationsService } from './shared/services/observations.service';
import { ToastService } from './shared/services/toast.service';
import { LastScansService } from './shared/services/lastScans.service';

@NgModule({
    declarations: [
        MyApp,
        HomepageComponent,
        MainNavigationComponent,
        HeaderComponent,
        RapportSansAccesComponent,
        ConnexionComponent,
        SavoirPlusComponent,
        DerniersScansComponent,
        ListeElementsVerifiesComponent,
        ElementVerifieComponent,
        RechercheComponent,
        RapportComponent,
        FiltresComponent,
        ListeObservationsRapportComponent,
        ListeObservationsVerifiesComponent,
        DetailsObservationComponent,
        SuiviObservationComponent,
        MotDePasseOublieComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        MomentModule,
        IonicStorageModule.forRoot({
            name: '__mydb'
        }),
        IonicModule.forRoot(MyApp, {
            scrollAssist: true,
            autoFocusAssist: true,
            monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
        })
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        HomepageComponent,
        MainNavigationComponent,
        HeaderComponent,
        RapportSansAccesComponent,
        ConnexionComponent,
        SavoirPlusComponent,
        DerniersScansComponent,
        ListeElementsVerifiesComponent,
        ElementVerifieComponent,
        RechercheComponent,
        RapportComponent,
        FiltresComponent,
        ListeObservationsRapportComponent,
        ListeObservationsVerifiesComponent,
        DetailsObservationComponent,
        SuiviObservationComponent,
        MotDePasseOublieComponent
    ],
    providers: [
        {
            provide: ErrorHandler, 
            useClass: IonicErrorHandler
        },
        InAppBrowser,
        StatusBar,
        SplashScreen,
        BarcodeScanner,
        Keyboard,
        MobileAccessibility,
        GoogleAnalytics,
        AndroidPermissions,
        Camera,
        ApiService,
        AuthService,
        ElementsService,
        RapportService,
        qrCodeService,
        ObservationsService,
        LastScansService,
        ToastService,
        NativeStorage,
        API
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts